function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zM16 .8C7.6.8.8 7.6.8 16S7.6 31.2 16 31.2 31.2 24.4 31.2 16 24.4.8 16 .8z" /><path d="M22.8 26.3L16 22.8l-6.8 3.6 1.3-7.5L5 13.4l7.6-1.1L16 5.5l3.4 6.9 7.6 1.1-5.5 5.3 1.3 7.5zM7.2 14.1l4.4 4.3-1 6.1 5.4-2.9 5.4 2.9-1-6.1 4.4-4.3-6.1-.9L16 7.7l-2.7 5.5-6.1.9z" /></svg>;
});